import script from "./IncidentSelectionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./IncidentSelectionModal.vue?vue&type=script&setup=true&lang=js"

import "./IncidentSelectionModal.vue?vue&type=style&index=0&id=8aadcc98&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8aadcc98"]])

export default __exports__